/**
 * Browser logger for production debugging.
 * Stores logs in localStorage and sends critical errors to backend if available.
 */

const MAX_LOGS = 500; // Keep last N logs in localStorage
const LOGS_KEY = 'selectify_logs';

function getTimestamp() {
  return new Date().toISOString();
}

function getLogs() {
  try {
    const stored = localStorage.getItem(LOGS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function addLog(level, message, context = {}) {
  try {
    const logs = getLogs();
    const entry = {
      timestamp: getTimestamp(),
      level,
      message,
      ...context,
      userAgent: navigator.userAgent
    };
    logs.push(entry);
    // Keep only last MAX_LOGS entries
    if (logs.length > MAX_LOGS) {
      logs.splice(0, logs.length - MAX_LOGS);
    }
    localStorage.setItem(LOGS_KEY, JSON.stringify(logs));
    
    // Also log to console in development
    const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
    const logFn = level === 'error' ? console.error : level === 'warn' ? console.warn : console.log;
    if (isDev) {
      logFn(`[${level.toUpperCase()}] ${message}`, context);
    }
  } catch (e) {
    console.error('Failed to log:', e);
  }
}

export const logger = {
  debug: (msg, ctx) => addLog('debug', msg, ctx),
  info: (msg, ctx) => addLog('info', msg, ctx),
  warn: (msg, ctx) => addLog('warn', msg, ctx),
  error: (msg, ctx) => addLog('error', msg, ctx),
  
  // Retrieve all stored logs
  getLogs: () => getLogs(),
  
  // Clear stored logs
  clearLogs: () => {
    try {
      localStorage.removeItem(LOGS_KEY);
    } catch (e) {
      console.error('Failed to clear logs:', e);
    }
  },
  
  // Export logs as JSON file
  exportLogs: () => {
    const logs = getLogs();
    const blob = new Blob([JSON.stringify(logs, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `selectify-logs-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
};
